import { render } from "./ScansionaColliUscitaForm.vue?vue&type=template&id=7744dc9e"
import script from "./ScansionaColliUscitaForm.vue?vue&type=script&lang=js"
export * from "./ScansionaColliUscitaForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__